import type { Article } from "@/components/resources/data/sanity/posts"
import { SchemaScript } from "./SchemaScript"

const makeSchema = ({ publishedAt, modifiedAt, title }: Article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  datePublished: publishedAt,
  dateModified: modifiedAt,
  // TODO: add author and publisher and possibly other stuff too
  // Also might be good to evaluate if we should use microschema for this one especially due images etc
})

export const ArticleSchema = ({ article }: { article: Article }) => (
  <SchemaScript id="article" schema={makeSchema(article)} />
)
